<div class="car-screen">

  <div class="car-head">
    <div class="car-head__copy">
      <h1 class="stk-page-title">Szállítók</h1>
      <div class="stk-page-sub">Szállító létrehozása, országok hozzárendelése és címke-beállítások.</div>
    </div>
    <button type="button" class="car-add-btn" (click)="addCarrier()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
      Új szállító
    </button>
  </div>

  <!-- Szállító választó -->
  <div class="car-tabs" *ngIf="carriers.length > 0">
    <button
      type="button"
      class="car-tab"
      [class.car-tab--on]="c.id === selectedId"
      *ngFor="let c of carriers; trackBy: trackByCarrier"
      (click)="selectCarrier(c)">
      {{ c.name }}
      <span
        *ngIf="c.id === selectedId"
        class="car-tab__x"
        title="Szállító törlése"
        (click)="removeCarrier(c, $event)">✕</span>
    </button>
  </div>

  <div class="car-empty" *ngIf="!fetchingCarriers && carriers.length === 0">
    Még nincs szállító — hozz létre egyet az „Új szállító” gombbal.
  </div>

  <!-- Név + országok -->
  <div class="car-card" *ngIf="selectedCarrier">
    <div class="car-name-row">
      <span class="car-micro">Szállító neve</span>
      <input
        class="car-name-input"
        type="text"
        [(ngModel)]="nameDraft"
        (change)="saveCarrierDetails()">
      <span class="car-micro">URL</span>
      <input
        class="car-url-input"
        type="text"
        placeholder="https://…"
        [(ngModel)]="urlDraft"
        (change)="saveCarrierDetails()">
    </div>
    <div class="car-micro car-countries-title">Kiszolgált országok</div>
    <div class="car-countries">
      <span class="car-country" *ngFor="let p of selectedCountries; trackBy: trackByPreferred">
        {{ p.country_iso }}
        <button type="button" class="car-country__x" title="Eltávolítás" (click)="removeCountry(p)">✕</button>
      </span>
      <input
        class="car-country-add"
        type="text"
        placeholder="+ ország (pl. DE)"
        [disabled]="addingCountry"
        [ngModel]="countryInput"
        (ngModelChange)="onCountryInput($event)"
        (keydown.enter)="addCountry()">
    </div>
  </div>

  <!-- Súly-alapú díjszabás (Spring GDS árlista) -->
  <div class="rate-card" *ngIf="selectedCarrier">
    <div class="rate-card__head">
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7 h13 v10 H3 Z"></path><path d="M16 10 h3.5 L21 13 v4 h-5 Z"></path><circle cx="7" cy="18.5" r="1.8"></circle><circle cx="17.5" cy="18.5" r="1.8"></circle></svg>
      <h3>Szállítási díjszabás</h3>
      <span>súly alapú árak zónánként — a rendelésnél ebből számol a rendszer</span>
    </div>

    <div class="rate-empty" *ngIf="loadingZones">Betöltés…</div>
    <div class="rate-empty" *ngIf="!loadingZones && !zones.length">
      Még nincs díjzóna ehhez a szállítóhoz — hozz létre egyet lent.
    </div>

    <!-- Zónák -->
    <div class="rate-zone" *ngFor="let zone of zones">
      <div class="rate-zone__head">
        <input class="rate-zone__name" type="text" [(ngModel)]="zone.name" (change)="saveZone(zone)" placeholder="Zóna neve">
        <input class="rate-zone__countries" type="text" [(ngModel)]="zone.countryText" (change)="saveZone(zone)"
               placeholder="Országkódok, pl. US, CA  —  gyűjtőzónánál üres">
        <label class="rate-zone__fallback" title="Gyűjtőzóna: akkor érvényes, ha egyik konkrét zóna sem illeszkedik">
          <input type="checkbox" [(ngModel)]="zone.is_fallback" (change)="saveZone(zone)">
          minden más ország
        </label>
        <span class="rate-saved" *ngIf="zone.savedFlash">mentve ✓</span>
        <button type="button" class="rate-zone__del" title="Zóna törlése" (click)="removeZone(zone)">✕</button>
      </div>

      <table class="rate-table">
        <thead>
          <tr>
            <th>Súlyhatár</th>
            <th>Szállítási díj</th>
            <th>Vámkezelés</th>
            <th>Felár %</th>
            <th>Összesen nettó</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rate of zone.rates">
            <td data-label="Súlyhatár"><input type="number" min="1" [(ngModel)]="rate.max_weight_grams" (change)="saveRate(zone, rate)"> g</td>
            <td data-label="Szállítási díj"><input type="number" min="0" step="0.01" [(ngModel)]="rate.shipping_fee" (change)="saveRate(zone, rate)"></td>
            <td data-label="Vámkezelés"><input type="number" min="0" step="0.01" [(ngModel)]="rate.customs_fee" (change)="saveRate(zone, rate)"></td>
            <td data-label="Felár %"><input type="number" min="0" step="0.01" class="rate-table__pct" [(ngModel)]="rate.surcharge_percent" (change)="saveRate(zone, rate)"></td>
            <td class="rate-table__total" data-label="Összesen nettó">
              {{ rateTotal(rate) | number:'1.0-2' }}
              <span class="rate-saved rate-saved--sm" *ngIf="rate.savedFlash">✓</span>
            </td>
            <td class="rate-table__del-cell"><button type="button" class="rate-table__del" title="Sáv törlése" (click)="removeRate(zone, rate)">✕</button></td>
          </tr>
          <tr class="rate-table__new">
            <td><input type="number" min="1" placeholder="új súlyhatár" [(ngModel)]="zone.newWeight" (keydown.enter)="addRate(zone)"> g</td>
            <td colspan="5"><button type="button" class="rate-table__add" (click)="addRate(zone)">+ Súlysáv hozzáadása</button></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Új zóna -->
    <div class="rate-newzone">
      <input type="text" [(ngModel)]="newZoneName" placeholder="Új zóna neve (pl. Kanada)">
      <input type="text" [(ngModel)]="newZoneCountries" placeholder="Országkódok, pl. CA">
      <button type="button" class="stk-btn stk-btn--dark" (click)="addZone()">Zóna hozzáadása</button>
    </div>

    <!-- Próba-kalkuláció -->
    <div class="rate-test">
      <span class="rate-test__label">Próba:</span>
      <input type="text" [(ngModel)]="testCountry" placeholder="ország (US)" maxlength="2">
      <input type="number" min="0" [(ngModel)]="testWeight" placeholder="súly (g)"> g
      <button type="button" class="rate-test__btn" (click)="runTestQuote()">Ár lekérdezése</button>
      <span class="rate-test__result" *ngIf="testQuote">
        {{ testQuote.zoneName }} · {{ testQuote.weightBracketGrams }} g sáv →
        <strong>{{ testQuote.totalNet | number:'1.0-2' }} Ft</strong>
        ({{ testQuote.shippingFee | number:'1.0-2' }} + {{ testQuote.customsFee | number:'1.0-2' }} + {{ testQuote.surchargeAmount | number:'1.0-2' }})
      </span>
    </div>
  </div>

  <!-- Címke-beállítások -->
  <div class="car-labels">
    <div class="car-labels__head">
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="18" rx="2"></rect><line x1="9" y1="8" x2="15" y2="8"></line><line x1="9" y1="12" x2="15" y2="12"></line><line x1="9" y1="16" x2="13" y2="16"></line></svg>
      <h3>Label típus logika</h3>
      <span>minden szállítóra közös — a címke papírmérete</span>
    </div>
    <div class="car-labels__body">
      <div class="car-labels__field">
        <label class="stk-label">Alap label (minden ország)</label>
        <input class="stk-input" type="text" [(ngModel)]="labelSettings.default_label_type">
      </div>
      <div class="car-labels__field">
        <label class="stk-label">USA külön label</label>
        <input class="stk-input" type="text" [(ngModel)]="labelSettings.usa_label_type">
      </div>
      <button
        type="button"
        class="stk-btn stk-btn--dark"
        [disabled]="savingLabelSettings"
        (click)="saveLabelSettings()">Mentés</button>
    </div>
  </div>

  <app-edit-carrier
    *ngIf="editorOpen"
    [carrier]="null"
    (closed)="closeEditor()"
    (saved)="onCarrierSaved($event)">
  </app-edit-carrier>

</div>
